module.exports = __webpack_public_path__ + "flu_pathmut_logo_v1@2x.png";